import React from "react";
import { Modal, Button } from "@mantine/core";
import dayjs from "dayjs";
import "./OrderItemDetailsModal.css";
import { Order } from "@/api/types";
import Receipt from "../../Shared/Receipt/Receipt";
import { PDFDownloadLink } from "@react-pdf/renderer";

interface OrderItemDetailsModalProps {
  opened: boolean;
  onClose: () => void;
  order: Order;
}

const OrderItemDetailsModal: React.FC<OrderItemDetailsModalProps> = ({
  opened,
  onClose,
  order,
}) => {
  const oneItem = order?.orderItems.length === 1;
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Detalji revije"
      centered
      size="xl"
      transitionProps={{ transition: "fade-up" }}
      classNames={{
        inner: "order-details-inner",
        content: "order-details-content",
        body: "order-details-body",
        header: "order-details-header",
        title: "order-details-title",
      }}
    >
      <div className="flex flex-col justify-between h-full order-details-root">
        <div className="flex flex-col gap-[1rem]">
          <div className="text-[#0b1a29] text-base font-bold">
            Detalji kupnje
          </div>
          <div className="flex justify-between items-center">
            <div className="flex flex-col gap-3 justify-start items-start w-full">
              <div className="flex flex-col gap-2 w-full">
                {order?.orderItems.map((orderItem) => (
                  <div
                    key={orderItem.id}
                    className="flex items-center justify-between w-full"
                  >
                    <div className="self-stretch text-[#0b1a29] text-sm font-medium">
                      {orderItem.subscription
                        ? orderItem.subscription.title
                        : orderItem.issue
                        ? orderItem.issue?.title
                        : orderItem.publication?.title}
                    </div>
                    {!oneItem && (
                      <div className="text-[#515151] text-sm font-medium">
                        {orderItem?.price}€
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className="text-[#515151] text-xs font-medium">
                Kupljeno: {dayjs(order?.createdAt).format("DD.MM.YYYY.")}
              </div>
              <div className="text-[#515151] text-sm font-bold">
                {order?.price}€
              </div>
            </div>
          </div>
        </div>
        <PDFDownloadLink
          document={<Receipt order={order} />}
          fileName={`${order.guid}.pdf`}
          className="order-details-modal-button-container"
        >
          {({ loading }) => (
            <Button
              variant="filled"
              color="#004a99"
              radius="xl"
              size="md"
              className="order-details-modal-button"
            >
              {loading ? "Učitavanje..." : "Preuzmi račun"}
            </Button>
          )}
        </PDFDownloadLink>
      </div>
    </Modal>
  );
};

export default OrderItemDetailsModal;
